import React, { useState } from 'react';
import { Card } from '@primitives';
import PDFFileIcon from '@cp/assets/images/icons/PDFFileIcon';
import CircularLoader from '@icons/CircularLoaderIcon/CircularLoaderIcon';
import { VisibilityIcon } from '@icons';
import { getFileDownload } from '@cp/utils/commonUtils';
import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { useParams } from 'react-router-dom';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { clickStreamConstants } from '@cp/pages/CaseDetails/components/AllDocumentsV2/clickStreamConstants';

type DynamicDocumentRendererProps = {
  type: string;
  uri: string;
  isDynamic: boolean;
  documentName: string;
  documentType: string;
};
function DynamicDocumentRenderer(document: DynamicDocumentRendererProps) {
  const [dynamicDocumentUrlLoading, setDynamicDocumentUrlLoading] = useState(false);
  const { loanId = '', customerId = '', caseReferenceId = '' } = useParams();
  const handleDownloadDynamicDocument = () => {
    addClickstreamEvent(clickStreamConstants.LH_DOCUMENT_DOWNLOAD_CLICKED, {
      lan: loanId,
      document_name: document.documentName,
      document_type: 'pdf'
    });
    setDynamicDocumentUrlLoading(true);
    const dynamicDocumentApiUrl = getApiUrl(ApiKeys.GENERATE_DYNAMIC_DOCUMENT_URL);
    axiosInstance
      .post(
        dynamicDocumentApiUrl,
        {
          documentGenerationType: document?.documentType,
          loanAccountNumber: loanId,
          metaData: { customerReferenceId: customerId }
        },
        {
          headers: { caseReferenceId }
        }
      )
      .then(response => {
        addClickstreamEvent(clickStreamConstants.LH_DOCUMENT_DOWNLOAD_SUCCESS, {
          lan: loanId,
          document_name: document.documentName,
          document_type: 'pdf'
        });
        if (response?.data?.uri) {
          getFileDownload(response?.data?.uri, true);
        }

        setDynamicDocumentUrlLoading(false);
      })
      .catch(err => {
        addClickstreamEvent(clickStreamConstants.LH_DOCUMENT_DOWNLOAD_FAILED, {
          lan: loanId,
          document_name: document.documentName,
          document_type: 'pdf'
        });
        setDynamicDocumentUrlLoading(false);
      });
  };
  return (
    <Card
      className="cursor-pointer bg-primary shadow-2 flex items-center gap-3  justify-between min-w-[247px] "
      onClick={() => handleDownloadDynamicDocument()}
    >
      <div className="flex gap-2 items-center">
        <PDFFileIcon />
        <div className="text-xs">{document?.documentName}</div>
      </div>
      <div>
        {dynamicDocumentUrlLoading ? (
          <CircularLoader size="sm" />
        ) : (
          <VisibilityIcon variant={'outlined'} color={'var(--blue-base)'} size="sm" />
        )}
      </div>
    </Card>
  );
}

export default DynamicDocumentRenderer;
